import React from 'react'

const getUserMetrics = async () => {

    //1. Get IP address using external service
    const getIP = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data?.ip;
        } catch (err) {
            console.error('Error fetching IP:', err);
            return null;
        }
    };

    // 2. Get network bandwidth (approx)
    const getBandwidth = () => {
        if (navigator.connection && navigator.connection?.downlink) {
            return navigator.connection.downlink + ' Mbps';
        }
        return 'Unknown';
    };

    // 3. Get device details from user agent
    const getDeviceDetails = () => {
        let ua=null;
        if(navigator.userAgent){
            ua = navigator.userAgent;
        }

        if (/iPhone/.test(ua)) return 'iPhone';
        if (/iPad/.test(ua)) return 'iPad';
        if (/Android/.test(ua)) return 'Android';
        if (/Macintosh/.test(ua)) return 'Mac';
        if (/Windows/.test(ua)) return 'Windows';
        if (/Linux/.test(ua)) return 'Linux';

        return 'Unknown';
    };

    // 4. Check if Mobile or Web
    const getPlatform = () => {
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);
        return isMobile ? 'Mobile' : 'Web';
    };

    // 5. Get website URL
    const getWebsiteUrl = () => window.location.href;

    const ip = await getIP();
    const bandwidth = getBandwidth();
    const device = getDeviceDetails();
    const platform = getPlatform();
    const websiteUrl = getWebsiteUrl();

    const userMetrics = {
        ip_address: ip,
        bandwidth,
        device,
        platform,
        website_url: websiteUrl
    };
    return userMetrics;

}

export default getUserMetrics